import { useState, useEffect } from "react";
import { Clock } from "lucide-react";

export default function CountdownTimer({ endDate, compact = false }) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = new Date(endDate) - new Date();
    
    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
      expired: false
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [endDate]);

  if (timeLeft.expired) {
    return (
      <div className={`flex items-center gap-2 ${compact ? 'text-sm' : ''}`}>
        <Clock className={`${compact ? 'h-3.5 w-3.5' : 'h-4 w-4'} text-red-500`} />
        <span className="text-red-500 font-medium">Finalizado</span>
      </div>
    );
  }

  const TimeUnit = ({ value, label }) => (
    <div className={`flex flex-col items-center ${compact ? '' : 'min-w-[60px]'}`}>
      <span 
        className={`countdown-number font-bold tabular-nums ${compact ? 'text-lg' : 'text-3xl'} text-orange-500`}
        style={{ fontFamily: 'JetBrains Mono, monospace' }}
      >
        {String(value).padStart(2, '0')}
      </span>
      {!compact && (
        <span className="text-xs text-muted-foreground uppercase tracking-wider">
          {label}
        </span>
      )}
    </div>
  );

  const Separator = () => (
    <span 
      className={`font-bold ${compact ? 'text-lg mx-0.5' : 'text-2xl mx-1'} text-orange-500`}
      style={{ fontFamily: 'JetBrains Mono, monospace' }}
    >
      :
    </span>
  );

  if (compact) {
    return (
      <div className="flex items-center gap-1.5">
        <Clock className="h-3.5 w-3.5 text-orange-500" />
        <div className="flex items-center">
          {timeLeft.days > 0 && (
            <>
              <TimeUnit value={timeLeft.days} />
              <Separator />
            </>
          )}
          <TimeUnit value={timeLeft.hours} />
          <Separator />
          <TimeUnit value={timeLeft.minutes} />
          <Separator />
          <TimeUnit value={timeLeft.seconds} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center gap-2 p-4 bg-orange-50 rounded-xl">
      {timeLeft.days > 0 && (
        <>
          <TimeUnit value={timeLeft.days} label="Días" />
          <Separator />
        </>
      )}
      <TimeUnit value={timeLeft.hours} label="Horas" />
      <Separator />
      <TimeUnit value={timeLeft.minutes} label="Min" />
      <Separator />
      <TimeUnit value={timeLeft.seconds} label="Seg" />
    </div>
  );
}
